import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { fetchProposalStep } from "ProposalAction";
import LocaleStrings from "Languages";

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {}

  redirectUrl = (e) => {
    e.preventDefault();
    let clicked_step = e.currentTarget.dataset.data_id;
    let clicked_stepArr = clicked_step.split("_");
    let {
      checkProposalForm,
      proposalReviewerStatus,
      proposalReviewCriteriaStatus,
      ProposalStep,
    } = this.props;
    let current_step = ProposalStep;
    let current_stepArr = current_step.split("_");

    let proposalFormList =
      checkProposalForm && checkProposalForm.length > 0
        ? checkProposalForm
        : [];
    let reviewerList =
      proposalReviewerStatus && proposalReviewerStatus.length > 0
        ? proposalReviewerStatus
        : [];
    let criteriaList =
      proposalReviewCriteriaStatus && proposalReviewCriteriaStatus.length > 0
        ? proposalReviewCriteriaStatus
        : [];

    let proposalid =
      proposalFormList && proposalFormList.length > 0
        ? proposalFormList[0]["proposalid"]
        : null;
    let formid =
      proposalFormList && proposalFormList.length > 0
        ? proposalFormList[0]["formid"]
        : null;

    let distribution =
      proposalFormList && proposalFormList.length > 0
        ? proposalFormList[0]["distribution"]
        : null;
    let reviewArr = [];
    let criteriaArr = [];

    if (reviewerList && reviewerList.length > 0 && proposalid) {
      reviewArr = _.filter(reviewerList, function (o) {
        return o.proposalidfk === proposalid;
      });
    }

    if (criteriaList && criteriaList.length > 0 && proposalid) {
      criteriaArr = _.filter(criteriaList, function (o) {
        return o.proposalidfk === proposalid;
      });
    }

    let nextStep = false;
    if (
      proposalFormList &&
      proposalFormList.length > 0 &&
      formid &&
      reviewArr.length > 0 &&
      criteriaArr &&
      criteriaArr.length > 0
    ) {
      nextStep = true;
    } else if (
      clicked_step == "step_2" &&
      proposalFormList &&
      proposalFormList.length > 0
    ) {
      nextStep = true;
    } else if (
      proposalFormList &&
      proposalFormList.length > 0 &&
      formid &&
      (reviewArr.length > 0 || distribution == "manual") &&
      clicked_step == "step_3"
    ) {
      nextStep = true;
    } else if (
      proposalFormList &&
      proposalFormList.length > 0 &&
      formid &&
      (reviewArr.length > 0 || distribution == "manual") &&
      criteriaArr &&
      criteriaArr.length > 0
    ) {
      nextStep = true;
    }

    if (clicked_stepArr[1] < current_stepArr[1]) {
      this.props.fetchProposalStep(clicked_step);
    } else if (clicked_stepArr[1] > current_stepArr[1] && nextStep) {
      this.props.fetchProposalStep(clicked_step);
    }
  };

  render() {
    let {
      checkProposalForm,
      proposalReviewerStatus,
      proposalReviewCriteriaStatus,
      ProposalStep,
    } = this.props;

    let proposalFormList =
      checkProposalForm && checkProposalForm.length > 0
        ? checkProposalForm
        : [];
    let reviewerList =
      proposalReviewerStatus && proposalReviewerStatus.length > 0
        ? proposalReviewerStatus
        : [];
    let criteriaList =
      proposalReviewCriteriaStatus && proposalReviewCriteriaStatus.length > 0
        ? proposalReviewCriteriaStatus
        : [];

    let formBuildeList =
      this.props.formBuildeList && this.props.formBuildeList.resource
        ? this.props.formBuildeList.resource
        : [];

    // console.log("ProposalStep", ProposalStep);
    // console.log("checkProposalForm", checkProposalForm);
    // console.log("reviewerList", reviewerList);
    // console.log("criteriaList", criteriaList);
    // console.log("proposalFormList", proposalFormList);

    let formIcon = "fa fa-exclamation-circle";
    let formStyle = "steps-not-filled";

    let designIcon = "fa fa-exclamation-circle";
    let designStyle = "steps-not-filled";

    let addreviewerIcon = "fa fa-exclamation-circle";
    let addreviewerStyle = "steps-not-filled";

    let criteriaIcon = "fa fa-exclamation-circle";
    let criteriaStyle = "steps-not-filled";

    let publishIcon = "fa fa-exclamation-circle";
    let publisStyle = "steps-not-filled";

    if (proposalFormList && proposalFormList.length > 0) {
      let proposalid = proposalFormList[0]["proposalid"];
      let ispublished = proposalFormList[0]["ispublished"];
      let distribution = proposalFormList[0]["distribution"];

      let reviewArr = [];
      let criteriaArr = [];

      if (proposalid) {
        formIcon = "fa fa-check-circle";
        formStyle = "steps-filled";
      }
      if (proposalFormList[0]["formid"]) {
        designIcon = "fa fa-check-circle";
        designStyle = "steps-filled";
      }

      if (distribution == "manual") {
        addreviewerIcon = "fa fa-check-circle";
        addreviewerStyle = "steps-filled";
      } else if (reviewerList && reviewerList.length > 0 && proposalid) {
        reviewArr = _.filter(reviewerList, function (o) {
          return o.proposalidfk === proposalid;
        });

        if (reviewArr && reviewArr.length > 0) {
          addreviewerIcon = "fa fa-check-circle";
          addreviewerStyle = "steps-filled";
        }
      }

      if (criteriaList && criteriaList.length > 0 && proposalid) {
        criteriaArr = _.filter(criteriaList, function (o) {
          return o.proposalidfk === proposalid;
        });

        if (criteriaArr && criteriaArr.length > 0) {
          criteriaIcon = "fa fa-check-circle";
          criteriaStyle = "steps-filled";
        }
      }

      if (ispublished) {
        publishIcon = "fa fa-check-circle";
        publisStyle = "steps-filled";
      }
    }

    let activeStep1 =
      ProposalStep == "step_1" ? "activestepColor" : "stepColor";
    let activeStep2 =
      ProposalStep == "step_2" ? "activestepColor" : "stepColor";
    let activeStep3 =
      ProposalStep == "step_3" ? "activestepColor" : "stepColor";
    let activeStep4 =
      ProposalStep == "step_4" ? "activestepColor" : "stepColor";
    let activeStep5 =
      ProposalStep == "step_5" ? "activestepColor" : "stepColor";

    return (
      <div>
        <ul className="wizard_breadcrumb breadcrumb-ipad">
          <li>
            <a href="#" data-data_id="step_1" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${formIcon} ${formStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                <div className={activeStep1}>
                  {LocaleStrings.proposal_wizard_tab_1}
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="#" data-data_id="step_2" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${designIcon} ${designStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                <div className={activeStep2}>
                  {LocaleStrings.proposal_wizard_tab_2}
                </div>
              </div>
            </a>
          </li>

          <li>
            <a href="#" data-data_id="step_3" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${addreviewerIcon} ${addreviewerStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                <div className={activeStep3}>
                  {LocaleStrings.proposal_wizard_tab_3}
                </div>
              </div>
            </a>
          </li>

          <li>
            <a href="#" data-data_id="step_4" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${criteriaIcon} ${criteriaStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                <div className={activeStep4}>
                  {LocaleStrings.proposal_wizard_tab_4}
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="#" data-data_id="step_5" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${publishIcon} ${publisStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                <div className={activeStep5}>
                  {LocaleStrings.proposal_wizard_tab_5}
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    checkProposalForm: state.checkProposalForm.data,
    ProposalStep: state.ProposalStep,
    proposalReviewerStatus: state.proposalReviewerStatus.data,
    proposalReviewCriteriaStatus: state.proposalReviewCriteriaStatus.data,
    formBuildeList: state.formBuildeList,
  };
}
export default connect(mapStateToProps, {
  fetchProposalStep,
})(Navigation);
